import { NotificationType } from '@/constants/notification-type'
import { formatPrice } from '@/utils/formatter'

import { User } from './user'

export interface Notification {
  id: number
  type: NotificationType
  isRead: boolean
  subscriptionFee: number
  price: number
  user: User
  postId?: number
  createdAt: string
}

export interface NotificationCount {
  all: number
  subscription: number
  follow: number
  purchase: number
  like: number
}

export interface NotificationMessage {
  data: Notification
  creatorId: number
  type: NotificationType
}

export const getNotificationContent = (notification: Notification) => {
  const { type, subscriptionFee, price } = notification

  if (type === NotificationType.Subscription) {
    return `subscribed to your profile for ${formatPrice()(subscriptionFee)}`
  } else if (type === NotificationType.Follow) {
    return 'followed you!'
  } else if (type === NotificationType.Purchase) {
    return `purchased your post for ${formatPrice()(price)}`
  }
  return 'liked you!'
}

export type WSMessageData = NotificationMessage

export function isNotificationMessage(data: WSMessageData): data is NotificationMessage {
  return 'data' in data && 'creatorId' in data && 'type' in data
}
